<template>
  <main class="charging-container" :class="device">
    <emat-loader :loading="loading" :global="true"></emat-loader>
    <div class="charging-row" v-if="device !== 'mobile'">
      <div class="charging-col">
        <configuration @previous="$emit('previous')"></configuration>
      </div>
      <div class="charging-col">
        <div class="image-container" v-if="device !== 'mobile'">
          <charging-station-image v-if="type && type.type === 'laadpaal'"></charging-station-image>
          <charging-pillar-image v-else></charging-pillar-image>
        </div>
      </div>
      <div class="charging-col">
        <order-menu @previous="$emit('previous')"></order-menu>
      </div>
    </div>
    <div v-else-if="device === 'mobile'" class="mobile-col">
      <order-menu @previous="$emit('previous')"></order-menu>
      <configuration @previous="$emit('previous')"></configuration>
    </div>
  </main>
</template>

<script>
import {mapGetters} from "vuex";

import EmatLoader from 'Components/General/Loader';

import Configuration from "./configuration/Configuration";
import OrderMenu from "./order/OrderMenu";
import ChargingStationImage from "./configuration/image/ChargingStationImage";
import ChargingPillarImage from "./configuration/image/ChargingPillarImage";

export default {
  name: "ChargingContainer",

  components: {
    OrderMenu,
    Configuration,
    EmatLoader,
    ChargingStationImage,
    ChargingPillarImage,
  },
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters({
      types: 'types/mappedById',
      type: 'types/current',
      device: 'getDevice',
    }),
  },
}
</script>

<style lang="scss">
.charging-container {
  max-width: 1250px;
  margin: 0 auto;
  position: relative;

  &.mobile {
    max-width: 100%;

    .charging-row {
      display: flex;
      align-content: stretch;
      justify-content: center;

      .charging-col {
        width: 100%;
        padding: 1rem;
        flex-grow: 1;

        &:first-child {
          margin-left: 10vh;
          width: 100%;
          flex-grow: unset;
        }

        &:last-child {
          width: 0;
          min-width: 0;
        }

        .image-container {
          position: relative;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            margin: 0 auto;
          }
        }
      }
    }
  }

  .charging-row {
    display: flex;
    align-content: stretch;
    justify-content: space-between;

    .charging-col {
      width: 33%;
      padding: 1rem;
      flex-grow: 1;

      &:first-child {
        width: 282px;
        flex-grow: unset;
      }

      &:last-child {
        min-width: 203px;
        width: 203px;
        max-width: 203px;
        flex-grow: unset;
      }

      .image-container {
        position: relative;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 400px;
          min-width: 100%;
          height: auto;
          max-height: 90vh;
          object-fit: contain;
          object-position: center;
        }
      }
    }
  }

  .mobile-col {
    padding-top: 104px;
    box-sizing: border-box;
    padding-bottom: 40px;
  }
}
</style>
